import { RootState } from '@/redux/store';
import { getToken } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ keys }: { children: ReactNode; keys?: string }) => {
//   const token = getToken();
//   const userDetails = useSelector((state: RootState) => state?.user?.user);
//   const isVerified = localStorage.getItem('isVerified') === 'true';
//   const permissionKey =
//     typeof userDetails?.designation?.menuBar == 'string'
//       ? JSON.parse(userDetails?.designation?.menuBar)
//       : [];
//   const hasPermission = keys ? permissionKey?.keyNames?.includes(keys) : true;
//   // if (!isVerified || !hasPermission) {
//   //   return <Navigate to={RoutesLink.dashboard} replace />;
//   // }

//   return token ? <Outlet /> : <Navigate to={RoutesLink?.Login} />;
// };

// export default ProtectedRoute;

interface IProtectedProps {
  keys?: string;
  children?: ReactNode;
}

const ProtectedRoute = ({ keys, children }: IProtectedProps) => {
  const token = getToken();
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const isDashboard = location.pathname === RoutesLink.dashboard;
  const permissionKey =
    typeof userDetails?.designation?.menuBar == 'string'
      ? JSON.parse(userDetails?.designation?.menuBar)
      : userDetails?.designation?.menuBar;
  if (!token) {
    return <Navigate to={RoutesLink.Login} replace />;
  }
  if (!isDashboard) {
    if (!userDetails?.isVerified && userDetails?.type === 0) {
      return <Navigate to={RoutesLink.dashboard} replace />;
    }
  }
  if (keys) {
    if (permissionKey?.keyNames?.includes(keys) == false) {
      return <Navigate to={RoutesLink.dashboard} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
